/**
 * Implementation of AuthLayout component
 *
 * @author - Harsh Tomar
 */

// Dependencies
import React from "react";
import { Outlet } from "react-router-dom";
import { FiShield } from "react-icons/fi";

export default function FullScreenLoader() {
  return (
    <div className="h-screen flex flex-col items-center bg-primary">
      {/* <div className="bg-primary" style={{ flex: 2 }}></div> */}
      <h1 className="text-white text-5xl font-extrabold mb-10 mt-40">
        <FiShield className="icon mr-1 text-6xl -mt-3" />
        Monitor<span className="text-accent">ly</span>
      </h1>

    </div>
  );
}
